import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const field = "w-full h-12 px-4 rounded-lg border border-sand bg-white text-ink focus:outline-none focus:ring-2 focus:ring-tea-hover/70 transition-shadow duration-200";

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch (err) {
      // A failure here is a client/network problem, not information about whether the
      // email exists — the backend deliberately hides that, and the UI below must too.
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6 font-body text-ink" data-testid="forgot-password-page">
      <div className="w-full max-w-sm animate-rise">
        {submitted ? (
          <div className="text-center">
            <p className="font-heading font-bold text-2xl">Check your inbox</p>
            <p className="text-ink/60 mt-2 [text-wrap:pretty]">
              If an account exists for that email, we've sent a password reset link. Check your inbox.
            </p>
            <a href="/login" className="inline-block mt-6 text-sm text-tea-text hover:underline">Back to login</a>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <h2 className="font-heading font-semibold text-2xl sm:text-3xl tracking-tight">Reset your password</h2>
            <p className="text-sm text-ink/60">Enter your email and we'll send you a link to reset it.</p>
            <div>
              <label className="text-xs uppercase tracking-[0.2em] font-medium text-ink/60">Email</label>
              <input required type="email" data-testid="forgot-password-email-input" className={`${field} mt-1`} value={email}
                onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button disabled={busy} data-testid="forgot-password-submit"
              className="w-full h-12 rounded-lg bg-tea hover:bg-tea-hover text-tea-text font-medium transition-[background-color,transform] duration-200 active:scale-[0.96] disabled:opacity-60 disabled:active:scale-100">
              {busy ? "Please wait…" : "Send reset link"}
            </button>
            <a href="/login" className="block text-center text-sm text-tea-text hover:underline">Back to login</a>
          </form>
        )}
      </div>
    </div>
  );
}
